export function baseUnitMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      baseUnitId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateBaseUnitId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateBaseUnitId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyBaseUnit(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      baseUnitId: resource.objectId,
    })),
  };
}

export function baseUnitMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, baseUnitId: json.result.objectId},
  };
}